import React from 'react';
import { Formatters, Messages } from '../../../../../gen-src/Localize';
import { SheetField } from './SheetField';
import { DetailsPaneSection, FieldsSectionHeader, SheetFieldsListBody } from './ViewerPaneStyles';
import { VizClientFieldElement } from './VizClientFieldElement';

export const dataDetailsSheetFieldsSectionTestId = 'data-details-sheet-fields-section';
export const dataDetailsSheetFieldsWithCountHeaderTestId = 'data-details-sheet-fields-with-count-header';

export interface SheetFieldsListProps {
  readonly workbookVizportalUrlId: string;
  readonly datasourceFields: ReadonlyArray<Readonly<SheetField>>;
  readonly worksheetFields: ReadonlyArray<Readonly<SheetField>>;
}

/** A widget to display a list of fields being used by the current sheet */
export function SheetFieldsList(props: SheetFieldsListProps) {
  const count = Formatters.formatCount(props.datasourceFields.length + props.worksheetFields.length);

  return (
    <DetailsPaneSection data-tb-test-id={dataDetailsSheetFieldsSectionTestId}>
      <FieldsSectionHeader data-tb-test-id={dataDetailsSheetFieldsWithCountHeaderTestId}>
        {Messages.SheetFieldsInUseWithCount({ count })}
      </FieldsSectionHeader>
      <SheetFieldsListBody data-tb-test-id='data-details-sheet-fields-list-body'>
        {props.datasourceFields.map((field) =>
          <VizClientFieldElement field={field} key={field.id} workbookVizportalUrlId={props.workbookVizportalUrlId} />)}
        {props.worksheetFields.map((field) =>
          <VizClientFieldElement field={field} key={field.id} />)}
      </SheetFieldsListBody>
    </DetailsPaneSection>
  );
}
